<script setup lang="ts">
import { Fold, Expand, Bell, HomeFilled } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { useUserStoreHook } from '@/store/modules/user'
const { isCollapse, toggleCollapse } = inject('isCollapse')

const isCollapseOpen = ref(isCollapse)
const router = useRouter()

const goHome = () => {
  router.push('/')
}
const handleLogout = () => {
  useUserStoreHook().logOut()
}
</script>
<template>
  <el-header class="flex items-center justify-between border-b w-full">
    <div class="flex items-center">
      <el-button @click="toggleCollapse" :icon="isCollapseOpen ? Expand : Fold" circle />
      <el-breadcrumb separator="/" class="ml-4">
        <el-breadcrumb-item>
          <el-icon size="30" class="cursor-pointer" color="#0770ed" @click="goHome"
            ><HomeFilled
          /></el-icon>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="flex items-center gap-4">
      <el-dropdown>
        <span class="flex items-center">
          <el-avatar :size="30" :src="$imageUrl('/assets/temp/default_avatr.png')" />
          <span class="ml-2">管理员</span>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <el-dropdown-item>个人中心</el-dropdown-item> -->
            <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>
</template>
<style scoped lang="scss">
:deep(.el-tooltip__trigger:focus-visible) {
  outline: unset;
}
</style>
